<div>
    <div class="content">
        <list-view [liste]="comptesListView" *ngIf="comptesListView"></list-view>
    </div>
</div>
